import _ from 'lodash';

export const getErrors = ({
  errors,
  name,
}: {
  errors: unknown;
  name: string;
}): { errorLabel: string | undefined; hasError: boolean } => {
  const errorLabel = _.get(errors, `${name}.message`);
  const hasError = !!_.get(errors, name);

  return { errorLabel, hasError };
};
